/**
 * Outlined "user with a checkmark" icon used to denote an action confirmed by a
 * person (e.g. a submission manually marked as submitted by the user).
 *
 * @param props.width - SVG width (defaults to `22`).
 * @param props.height - SVG height (defaults to `22`).
 * @param props.stroke - Stroke color for the glyph (defaults to green `#008F32`).
 * @returns The rendered user-check SVG icon.
 */
const UserCheckIcon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      stroke={props.stroke || "#008F32"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserCheckIcon;
